
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
   providedIn: 'root'
})
export class SEOService {

  constructor(@Inject(DOCUMENT) private dom) {
  }

  updateCanonicalUrl(url:string, alternateUrls?: {
    it: string,
    en: string,
  }){
    const head = this.dom.getElementsByTagName('head')[0];
    let element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
    if (element==null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel','canonical')
    element.setAttribute('href',url)

    this.setHreflangAlternates(url, alternateUrls)
  }

  private setHreflangAlternates(url: string, alternateUrls?: {
    it: string,
    en: string,
  }){
    const head = this.dom.getElementsByTagName('head')[0];
    const u = new URL(url)

    for(let lang of ['it','en', 'x-default']){
      const path = environment.canonicalUrl+(lang === 'x-default' ? 'en' : lang)+u.pathname.replaceAll('/en/','/').replaceAll('/it/','/')

      const alternateUrl = alternateUrls?.[lang] ?? path

      let element: HTMLLinkElement= this.dom.querySelector(`link[hreflang='${lang}']`) || null
      if (element==null) {
        element= this.dom.createElement('link') as HTMLLinkElement;
        head.appendChild(element);
      }
      element.setAttribute('rel','alternate')
      element.setAttribute('href',alternateUrl)
      element.setAttribute('hreflang',lang)

    }


  }
}
